<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-添加活动
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form"  :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form"></Basic>



        <!--打卡规则-->
        <Clock :form="form"></Clock>

        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import SweepstakesApi from '@/api/sweepstakes.js';
import Basic from './part/Basic.vue';

import Clock from './part/Clock.vue';
import Other from './part/Other.vue';
export default {
  components: {
    /*基础设置*/
    Basic,

    /*活动商品*/
    Clock,
    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        /*活动名称*/
        sweepstakes_name: '',
        /*广告图片ID*/
        image_id: 0,
        /*抽奖转盘图片ID*/
        turntable_id:0,
        type:10,
        /*活动广告图*/
        file_path:'',
        /*抽奖转盘图片*/
        turntable_path:'',
        gradeList:[],
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        /*默认排序*/
        sort: 100,
        /*打卡规则介绍*/
        sweepstakes_content:'',
        /*打卡规则设置*/
        sweepstakes_rules:{

          /*抽奖选项*/
          reward_data: [],

        },
        /*抽奖选项*/
        awards:[],
        /*等级限抽*/
        grade_limit:[],
      },
      /*判断是否正在加载*/
      loading: false,


    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      SweepstakesApi.getAddSweepstakes({}, true )
        .then(res => {
          console.log(res)
          self.form.gradeList = res.data.gradeList;

          self.loading = false;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.points;
      });
      return obj;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.form.sweepstakes_rules.consume_points = self.convertJson(self.form.gradeList);
          let params = self.form;
          // console.log(params);
          // return;
          self.loading = true;
          SweepstakesApi.addSweepstakes(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/sweepstakes/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*表格数据格式化*/
    tableFormet(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id:item.assemble_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      curItem.spec_list = spec_list;
      newList.push(curItem);
      return newList;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/add.vue